import { render, staticRenderFns } from "./StepArea.vue?vue&type=template&id=11bb0296&"
import script from "./StepArea.vue?vue&type=script&lang=js&"
export * from "./StepArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports